import { WizAuthority } from '@/containers/common'
export default (managerTargetScopeRecord, useTargetScopeRecord, type) => {
  let columnDefs = []
  type && type == 1 ? 
  columnDefs = [{
    title: "受众设置",
    name: "useTargetScopeRecord",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: useTargetScopeRecord,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  }] :
  columnDefs = [{
    title: "管理权限",
    name: "managerTargetScopeRecord",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: managerTargetScopeRecord,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  },
  {
    title: "使用权限",
    name: "useTargetScopeRecord",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: useTargetScopeRecord,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  }]
  return columnDefs;
}
